import axios from '@/axios.js'

let entityURL = 'reports'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}

const state = {
    reportActiveDates: [],
}

const getters = {
    getReportActiveDates: (state) => (state.reportActiveDates)
}

const actions = {
    // Fetch Active Dates
    async fetchReportActiveDates({commit}) {
        const response = await axios(`${entityURL}/get-report-active-dates`)
        commit('SET_REPORT_ACTIVE_DATES', response.data)
    },
}

const mutations = {
    SET_REPORT_ACTIVE_DATES: (state, data) => (state.reportActiveDates = data),
}

export default {state, getters, actions, mutations}
